interface Props {
    title: string;
    subTitle: string | undefined;
}

export default function PolicyContentHeaderAction({ title, subTitle }: Props) {
    return (
        <div className="min-w-0 flex-1">
            <h2 className="text-xs font-semibold text-[#186cb2]">
                {title}
            </h2>
            {subTitle && (<p className="text-xs text-gray-600">{subTitle}</p>)}
        </div>
    )
}
